import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const HairBeauty: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_488)">
                <IconPath
                    d="M16.5 14.25C11.71 14.25 4.53 12.34 1.83 11.57C1.51843 11.4791 1.24473 11.2896 1.05 11.03C0.855267 10.7704 0.75 10.4546 0.75 10.13V4.87C0.75 4.54545 0.855267 4.22964 1.05 3.97C1.24473 3.71036 1.51843 3.52088 1.83 3.43C4.5 2.66 11.71 0.75 16.5 0.75C18.2902 0.75 20.0071 1.46116 21.273 2.72703C22.5388 3.9929 23.25 5.70979 23.25 7.5C23.25 9.29021 22.5388 11.0071 21.273 12.273C20.0071 13.5388 18.2902 14.25 16.5 14.25ZM16.5 14.25C15.5879 14.2434 14.6767 14.19 13.77 14.09L13.12 19.92C13.0734 20.3408 13.1164 20.7666 13.2462 21.1696C13.376 21.5726 13.5895 21.9435 13.8729 22.2581C14.1563 22.5726 14.503 22.8236 14.8903 22.9946C15.2776 23.1655 15.6967 23.2526 16.12 23.25H17.27C18.0656 23.25 18.8287 22.9339 19.3913 22.3713C19.9539 21.8087 20.27 21.0456 20.27 20.25V13.11C19.1562 13.8597 17.8426 14.2569 16.5 14.25ZM17.25 0.79V14.21M5.75 2.4V12.6"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_488">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
